module.exports = __webpack_public_path__ + "SuryaVamsi1-e209d6b9.png";